import configInstance, { SeBarConfig } from './config'
import locationInstance, { LocationService } from './location'

export class AuthUrls {

  constructor(
    private readonly config: SeBarConfig,
    private readonly location: LocationService,
  ) {}

  public getSignInUrl() {
    const baseSignInUrl = this.config.signInUrl
    const separator = baseSignInUrl.includes('?') ? '&' : '?'

    return `${baseSignInUrl}${separator}user_return_to=${encodeURIComponent(this.location.hrefFiltered)}`
  }

  public getSignOutUrl(redirectUri?: string): string {
    const baseSignOutUrl = this.config.signOutUrl
    const separator = baseSignOutUrl.includes('?') ? '&' : '?'
    const encodedRedirectUri = encodeURIComponent(redirectUri || this.getSignInUrl())
    return `${baseSignOutUrl}${separator}redirect_uri=${encodedRedirectUri}`
  }

}

export default new AuthUrls(configInstance, locationInstance)
